<template>
<div>
  <!-- Action buttons -->
  <el-row>
    <el-col :span="24">
      <el-card shadow="never" style="height: 100%;">
        <div class="row">
          <div class="col-md-5">
            <date-range-picker :from="queryParams.from" :to="queryParams.to" @on-change="applyDateRange"
              :shortcuts="dateRangeShortcuts" :earliest="dateRangePickerEarliest">
            </date-range-picker>
          </div>
          <div class="col-md-7">
            <el-button type="danger" round :disabled="shop === undefined"
              icon="el-icon-download" @click="doExport">
              {{ $t("ShopStat.Order_List_Details") }}
            </el-button>
            <el-switch class="px-4" v-model="queryParams.timeBasedOn" @change="applyBasedTimeRange"
              active-color="#13CE66" inactive-color="#439CFE"
              :active-text="displayLabels.LABEL_TAKE_MEAL_TIME" :inactive-text="$t('ShopStat.Order_Time')"
              active-value="take_meal_time" inactive-value="created_at">
            </el-switch>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
  
  <br>

  <!-- ACCOUNT-SELECTOR -->
  <el-row :gutter="5" type="flex">
    <el-col :sm="24" :md="12">
      <el-card shadow="never" style="height: 100%;">
        <!-- <account-selector :user="user" @apply-account="applyAccount">
        </account-selector> -->
        <ShopFinder @shop-selected="onShopSelected" @si-selected="onSiSelected"></ShopFinder>
      </el-card>
    </el-col>
  </el-row>

  <br>

  <!-- Charts & figures part -->
  <div v-if="shop">
    
    <div class="row">

      <!-- General Stats -->
      <div class="col-12 col-md-6">
        <div class="card card-stats">
          <div class="row card-body">
            <div class="col-12 col-md-4">
              <div class="statistics">
                <div class="info">
                  <div class="icon icon-primary">
                    <i class="now-ui-icons business_money-coins"></i>
                  </div>
                  <h3 class="info-title">
                    <small>$</small><animated-number :value="stat.amount_all"></animated-number>
                  </h3>
                  <h6 class="stats-title">{{$t("ShopStat.Total_Revenue")}}</h6>
                  <h5 class="info-title">
                    <small>$</small><animated-number :value="stat.amount_online"></animated-number>
                  </h5>
                  <h6 class="stats-title">{{$t("ShopStat.Online_Payment")}}</h6>
                  
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="statistics">
                <div class="info">
                  <div class="icon icon-success">
                    <i class="now-ui-icons files_paper"></i>
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="stat.count_all"></animated-number>
                  </h3>
                  <h6 class="stats-title">{{$t("ShopStat.Total_Order_Count")}}</h6>
                  <h5 class="info-title">
                    <animated-number :value="stat.count_online"></animated-number>
                  </h5>
                  <h6 class="stats-title">{{$t("ShopStat.Online_Payment_Order_Count")}}</h6>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="statistics">
                <div class="info">
                  <div class="icon icon-warning">
                    <i class="now-ui-icons users_single-02"></i>
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="stat.count_users"></animated-number>
                  </h3>
                  <h6 class="stats-title">{{$t("ShopStat.Number_Of_Ordering_Members")}}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Delivery Platform Stats -->
      <div class="col-12 col-md-6">
        <div class="card">
          <el-table :data="tableOfPlatformStats">
            <el-table-column :label="$t('ShopStat.Ordering_Platform')" header-align="center">
              <div slot-scope="{row}" class="d-flex justify-content-center">
                <img :src="row.src" style="max-height: 48px; max-width: 84px;" v-if="row.src">
                <!-- <span class="h5" v-if="row.text">{{ row.text }}</span> -->
              </div>
            </el-table-column>
            <el-table-column :label="$t('ShopStat.Order_Count')" header-align="right" property="count">
              <div slot-scope="{row}" class="text-right h4">
                <animated-number :value="row.count"></animated-number>
              </div>
            </el-table-column>
            <el-table-column :label="$t('ShopStat.Revenue')" header-align="right" property="amount">
              <div slot-scope="{row}" class="text-right h4">
                $<animated-number :value="row.amount"></animated-number>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>


      <!-- Pie charts -->
      <div class="col-12 col-md-3">
        <card class="card-chart" no-footer-line>
          <div class="chart-area">
            <pie-chart
              :chart-data="pie1"
              :height="220">
            </pie-chart>
          </div>
          <div slot="footer" class="stats d-flex justify-content-center">
            <h6 class="stats-title">{{ $t('ShopStat.Order_Count_Parentheses', {title: $t('ShopStat.Online_Payment_Ratios')}) }}</h6>
          </div>
        </card>
      </div>
      <div class="col-12 col-md-3">
        <card class="card-chart" no-footer-line>
          <div class="chart-area">
            <pie-chart
              :chart-data="pie2"
              :height="220">
            </pie-chart>
          </div>
          <div slot="footer" class="stats d-flex justify-content-center">
            <h6 class="stats-title">{{ $t('ShopStat.Amount_Parentheses', {title: $t('ShopStat.Online_Payment_Ratios')}) }}</h6>
          </div>
        </card>
      </div>
      <div class="col-12 col-md-3">
        <card class="card-chart" no-footer-line>
        <div class="chart-area">
          <pie-chart
            :chart-data="pie3"
            :height="220">
          </pie-chart>
        </div>
        <div slot="footer" class="stats d-flex justify-content-center">
          <h6 class="stats-title">{{ $t('ShopStat.Order_Count_Parentheses', {title: `${displayLabels.LABEL_MEAL_TYPES}${$t('ShopStat.Ratio')}`}) }}</h6>
          </div>
        </card>
      </div>
      <div class="col-12 col-md-3">
        <card class="card-chart" no-footer-line>
          <div class="chart-area">
            <pie-chart
              :chart-data="pie4"
              :height="220">
            </pie-chart>
          </div>
          <div slot="footer" class="stats d-flex justify-content-center">
            <h6 class="stats-title">{{ $t('ShopStat.Amount_Parentheses', {title: `${displayLabels.LABEL_MEAL_TYPES}${$t('ShopStat.Ratio')}`}) }}</h6>
          </div>
        </card>
      </div>

    
      <!-- Trend charts -->
      <div class="col-12 col-md-3">
        <card class="card-chart" no-footer-line>
          <div class="chart-area">
            <trend-chart
              :chart-data="trend1"
              :options="trendChartOptions"
              :height="220">
            </trend-chart>
          </div>
          <div slot="footer" class="stats d-flex justify-content-center">
            <h6 class="stats-title">{{ $t('ShopStat.Order_Count_Parentheses', {title: $t('ShopStat.Transaction_Type')}) }}</h6>
          </div>
        </card>
      </div>
      <div class="col-12 col-md-3">
        <card class="card-chart" no-footer-line>
          <div class="chart-area">
            <trend-chart
              :chart-data="trend2"
              :options="trendChartOptions"
              :height="220">
            </trend-chart>
          </div>
          <div slot="footer" class="stats d-flex justify-content-center">
            <h6 class="stats-title">{{ $t('ShopStat.Amount_Parentheses', {title: $t('ShopStat.Transaction_Type')}) }}</h6>
          </div>
        </card>
      </div>
      <div class="col-12 col-md-3">
        <card class="card-chart" no-footer-line>
          <div class="chart-area">
            <trend-chart
              :chart-data="trend3"
              :options="trendChartOptions"
              :height="220">
            </trend-chart>
          </div>
          <div slot="footer" class="stats d-flex justify-content-center">
            <h6 class="stats-title">{{ $t('ShopStat.Order_Count_Parentheses', {title: `${displayLabels.LABEL_MEAL_TYPES}${$t('ShopStat.Trend')}`}) }}</h6>
          </div>
        </card>
      </div>
      <div class="col-12 col-md-3">
        <card class="card-chart" no-footer-line>
          <div class="chart-area">
            <trend-chart
              :chart-data="trend4"
              :options="trendChartOptions"
              :height="220">
            </trend-chart>
          </div>
          <div slot="footer" class="stats d-flex justify-content-center">
            <h6 class="stats-title">{{ $t('ShopStat.Amount_Parentheses', {title: `${displayLabels.LABEL_MEAL_TYPES}${$t('ShopStat.Trend')}`}) }}</h6>
          </div>
        </card>
      </div>

      <!-- Top-products -->
      <div class="col-12 col-md-6">
        <h5>{{ $t('ShopStat.Sold_Items') }}</h5>
        <data-tables
          :data="products"
          :pagination-props="{pageSizes: [5, 10, 50]}"
          :table-props="productTableProps">
          <el-table-column prop="product" :label="$t('ShopStat.Product')" sortable="custom">
          </el-table-column>
          <el-table-column prop="image" :label="$t('ShopStat.Image')" width="120" align="center">
            <template slot-scope="{row}">
              <!-- <object :data="defaultProductImage" type="image/png"> -->
                <img :src="row.image || defaultProductImage" alt="...">
              <!-- </object> -->
            </template>
          </el-table-column>
          <el-table-column prop="qty" :label="$t('ShopStat.Quantity')" width="108" align="right" sortable="custom">
          </el-table-column>
          <el-table-column prop="total" :label="$t('ShopStat.Subtotal')"  width="120" align="right" sortable="custom" :render-header="addTooltipTotal">
            <div slot-scope="{row}">${{Number(row.total).toLocaleString()}}</div>
          </el-table-column>
        </data-tables>
      </div>

      <!-- Daily order trend (line chart) -->
      <div class="col-md-6">
        <h5>{{$t('ShopStat.Daily_Sales_Curve')}}</h5>
        <el-card shadow="never">
          <el-date-picker
            v-model="singleDayTrend.date" @change="drawSingleDayTrend" :clearable="false"
            type="date" :placeholder="$t('ShopStat.Message.Select_date')">
          </el-date-picker>

          <br><br>

          <card class="card-chart" no-footer-line>
            <div class="chart-area">
              <line-chart
                :chart-data="singleDayTrend.chartData1"
                :height="220">
              </line-chart>
            </div>
            <div slot="footer" class="stats d-flex justify-content-center">
              <h6 class="stats-title">{{ $t('ShopStat.Order_Count_Parentheses', { title: $t('ShopStat.Daily_Sales_Curve') }) }}</h6>
            </div>
          </card>
          <card class="card-chart" no-footer-line>
            <div class="chart-area">
              <line-chart
                :chart-data="singleDayTrend.chartData2"
                :height="220">
              </line-chart>
            </div>
            <div slot="footer" class="stats d-flex justify-content-center">
              <h6 class="stats-title">{{ $t('ShopStat.Revenue_Parentheses', { title: $t('ShopStat.Daily_Sales_Curve') }) }}</h6>
            </div>
          </card>
        </el-card>
      </div>

    </div>


    <!-- FOR ADVANCED CHARTS -->
    <el-divider><el-button type="text" @click="goToAdvShopStat">{{$t('ShopStat.View_Advanced_Charts')}}</el-button></el-divider>

  </div>

  <div class="col-12 d-flex justify-content-center" v-else>
    <h5>{{$t('ShopStat.Message.Choose_shop')}}</h5>
  </div>
  
</div>
</template>

<script>
import {
  AnimatedNumber
} from 'src/components';
import DateRangePicker from 'src/components/DateRangePicker';
import TrendChart from 'src/components/Charts/TrendChart';
import PieChart from 'src/components/Charts/PieChart';
import LineChart from "src/components/Charts/LineChart";
// import AccountSelector from './AccountSelector.vue';
import ShopFinder from 'src/components/ShopFinder.vue';

import { DataTables } from "vue-data-tables";

import Chart from 'chart.js';
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels';
//WARNING: We give datalabels anchoring settings by default, try not to change them~
Chart.defaults.global.maintainAspectRatio = false;
Chart.defaults.global.plugins.datalabels.anchor = 'end';//So that number label is attached to the "top" of each bar.
Chart.defaults.global.plugins.datalabels.font = {weight: 'bold'};
Chart.defaults.global.plugins.datalabels.formatter = function (val, ctx) {
  return val > 0? val: '';//Only show datalabels for non-zero values.
};

import axios from 'axios';
import moment from 'moment';
import { i18n } from "../../../vue-i18n-plugin";

export default {
  components: {
    TrendChart, PieChart, LineChart,
    ChartJSPluginDatalabels,
    AnimatedNumber,
    DateRangePicker,
    // AccountSelector,
    ShopFinder,

    DataTables
  },

  mounted() {
    // Adjust wordings accordingly.
    if (this.$route.meta.retail === true) {
      this.labels = {
        LABEL_EAT_IN: '自取',
        LABEL_TO_GO: '自定義',
        LABEL_TAKEAWAY: '自定義-2',
        LABEL_DELIVERY: '宅配',
        LABEL_MEAL_TYPES: '取件型態',
        LABEL_TAKE_MEAL_TIME: '取件時間'
      };
    }
    else {
      this.labels = {
        LABEL_EAT_IN: '內用',
        LABEL_TO_GO: '自取',
        LABEL_TAKEAWAY: '外帶',
        LABEL_DELIVERY: '外送',
        LABEL_MEAL_TYPES: '取餐型態',
        LABEL_TAKE_MEAL_TIME: '取餐時間'
      };
    }

    //FIXME: pre-determined shop ID via query string.
    if (this.$route.query.shopId)
      this.shop = {id: this.$route.query.shopId};
    if (this.shop && this.shop.id > 0)
      this.getStat();
  },

  methods: {
    getStat() {
      let from = moment(this.queryParams.from);
      let to = moment(this.queryParams.to);

      // Get general statistics.
      axios.get(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/shops/${this.shop.id}/stat?from=${from.unix()}&to=${to.unix()}`
        + (this.queryParams.timeBasedOn !== 'created_at'? `&timeRangeAttr=${this.queryParams.timeBasedOn}`: '')
      )
      .then(response => {
        // console.log('getStat', response.data);
        this.stat = response.data.stat;
        this.drawPies(this.stat);
        this.drawTrends(response.data.dates);
      })
      .catch(err => {
        console.log(`Cannot get stat`, err);
        let errMessage;
        if (err.data && err.data.code) {
          if (err.data.code == 'PROTOCOL_SEQUENCE_TIMEOUT')
            errMessage = this.$t("ShopStat.Message.Narrow_your_query");
          else
            errMessage = err.data.message
        }
        this.$notify.error({
          title: this.$t("ShopStat.Message.Query_failed_for_statistics"),
          message: errMessage
        });
        this.resetStat();
      });

      // Get product list.
      axios.get(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/shops/${this.shop.id}/products?from=${from.unix()}&to=${to.unix()}&limit=-1`
        + (this.queryParams.timeBasedOn !== 'created_at'? `&timeRangeAttr=${this.queryParams.timeBasedOn}`: '')
      )
      .then(response => {
        console.log('getProducts', response.data);
        this.products = response.data.products;
      })
      .catch(err => {
        console.log(`Cannot get products`, err);
        this.products = [];
      });

      this.drawSingleDayTrend();//FIXME: Update this every time the getStat() re-triggered?
    },

    applyDateRange(dates) {
      this.queryParams.from = dates[0];
      this.queryParams.to = dates[1];
      if (this.shop && this.shop.id > 0)
        this.getStat();
    },
    // applyAccount(si, eaa, shop) {
    //   console.log(`[SHOP-STAT] applyAccount: SI`, si);
    //   console.log(`[SHOP-STAT] applyAccount: EAA`, eaa);
    //   console.log(`[SHOP-STAT] applyAccount: shop`, shop);
    //   this.si = si;
    //   this.eaa = eaa;
    //   this.shop = shop;
    //   if (this.shop && this.shop.id > 0)
    //     this.getStat();
    //   else
    //     this.resetStat();
    // },
    applyBasedTimeRange() {
      if (this.shop && this.shop.id > 0)
        this.getStat();
    },
    onSiSelected(siId) {
      this.si = { id: siId };
    },
    onShopSelected(shopId, shopName) {
      this.shop = { id: shopId, name: shopName };
      if (shopId)
        this.getStat();
    },

    doExport() {
      if (this.shop === undefined) return;

      let from = moment(this.queryParams.from).startOf('day');
      let to = moment(this.queryParams.to).endOf('day');
      if (to.diff(from, 'days') > 7) {
        alert(this.$t("ShopStat.Message.Up_to_one_week_for_export"));
        return;
      }
      const defaultPlatformName = i18n.locale == 'en'?
        (process.env.VUE_APP_BRANDNAME_EN || process.env.VUE_APP_BRANDNAME) :
        process.env.VUE_APP_BRANDNAME;
      window.open(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/orders/export`
        + `?lang=${i18n.locale}&dateType=datetime&joinShopNames=true&includeNotes=true`
        + `&from=${from.unix()}&to=${to.unix()}&shopId=${this.shop.id}`
        + (this.queryParams.timeBasedOn !== 'created_at'? `&timeRangeAttr=${this.queryParams.timeBasedOn}`: '')
        + `&sort=id:asc&includeCarts=true&limit=-1&fileInitial=${this.shop.name}&defaultPlatformName=${encodeURIComponent(defaultPlatformName)}`
      );
    },

    drawPies(stat) {
      this.pie1 = {
        labels: ['Apple Pay', 'Google Pay', 'Line Pay', this.$t("ShopStat.Credit_Card"), this.$t("ShopStat.Others")],
        datasets: [
          {
            data: [stat.count_apple, stat.count_google, stat.count_line, stat.count_direct, stat.count_online_others],
            backgroundColor: ['silver', 'tomato', 'lime', 'gold', '#BC8F8F']
          }
        ]
      };
      this.pie2 = {
        labels: ['Apple Pay', 'Google Pay', 'Line Pay', this.$t("ShopStat.Credit_Card"), this.$t("ShopStat.Others")],
        datasets: [
          {
            data: [stat.amount_apple, stat.amount_google, stat.amount_line, stat.amount_direct, stat.amount_online_others],
            backgroundColor: ['silver', 'tomato', 'lime', 'gold', '#BC8F8F']
          }
        ]
      };
      this.pie3 = {
        labels: [this.labels.LABEL_EAT_IN, this.labels.LABEL_TO_GO, this.labels.LABEL_TAKEAWAY, this.labels.LABEL_DELIVERY],
        datasets: [
          {
            data: [stat.count_eat_in, stat.count_to_go, stat.count_takeaway, stat.count_delivery],
            backgroundColor: ['#80bfff', '#ffec80', '#8fce00', '#ff80c3']
          }
        ]
      };
      this.pie4 = {
        labels: [this.labels.LABEL_EAT_IN, this.labels.LABEL_TO_GO, this.labels.LABEL_TAKEAWAY,  this.labels.LABEL_DELIVERY],
        datasets: [
          {
            data: [stat.amount_eat_in, stat.amount_to_go, stat.amount_takeaway, stat.amount_delivery],
            backgroundColor: ['#80bfff', '#ffec80', '#8fce00', '#ff80c3']
          }
        ]
      };
    },

    drawTrends(dates) {
      //NOTE: You must assign the entire object rather than one prop after another.
      // Otherwise the chart won't update.
      this.trend1 = {
        labels: _pluck(dates, 'date'),
        datasets: [
          {
            label: this.$t("ShopStat.Payment_On_Site"), backgroundColor: '#afcecf', stack: 'stack1',
            data: _pluck(dates, 'cash_order_count')
          },
          {
            label: this.$t("ShopStat.Online_Payment"), backgroundColor: '#ffd280', stack: 'stack1',
            data: _pluck(dates, 'online_order_count')
          }
        ]
      };
      this.trend2 = {
        labels: _pluck(dates, 'date'),
        datasets: [
          {
            label: this.$t("ShopStat.Payment_On_Site"), backgroundColor: '#afcecf', stack: 'stack1',
            data: _pluck(dates, 'cash_amount')
          },
          {
            label: this.$t("ShopStat.Online_Payment"), backgroundColor: '#ffd280', stack: 'stack1',
            data: _pluck(dates, 'online_amount')
          }
        ]
      };
      this.trend3 = {
        labels: _pluck(dates, 'date'),
        datasets: [
          {
            label: this.labels.LABEL_EAT_IN, backgroundColor: '#80bfff', stack: 'stack1',
            data: _pluck(dates, 'eat_in_order_count')
          },
          {
            label: this.labels.LABEL_TO_GO, backgroundColor: '#ffec80', stack: 'stack1',
            data: _pluck(dates, 'to_go_order_count')
          },
          {
            label: this.labels.LABEL_TAKEAWAY, backgroundColor: '#8fce00', stack: 'stack1',
            data: _pluck(dates, 'takeaway_order_count')
          },
          {
            label: this.labels.LABEL_DELIVERY, backgroundColor: '#ff80c3', stack: 'stack1',
            data: _pluck(dates, 'delivery_order_count')
          }
        ]
      };
      this.trend4 = {
        labels: _pluck(dates, 'date'),
        datasets: [
          {
            label: this.labels.LABEL_EAT_IN, backgroundColor: '#80bfff', stack: 'stack1',
            data: _pluck(dates, 'eat_in_amount')
          },
          {
            label: this.labels.LABEL_TO_GO, backgroundColor: '#ffec80', stack: 'stack1',
            data: _pluck(dates, 'to_go_amount')
          },
          {
            label: this.labels.LABEL_TAKEAWAY, backgroundColor: '#8fce00', stack: 'stack1',
            data: _pluck(dates, 'takeaway_amount')
          },
          {
            label: this.labels.LABEL_DELIVERY, backgroundColor: '#ff80c3', stack: 'stack1',
            data: _pluck(dates, 'delivery_amount')
          }
        ]
      };
    },
    drawSingleDayTrend() {
      if (!this.singleDayTrend.date) return;
      let from = moment(this.singleDayTrend.date).startOf('day');
      let to = moment(this.singleDayTrend.date).endOf('day');
      // Get per-day order trend.
      axios.get(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/shops/${this.shop.id}/trends?period=hourly&from=${from.unix()}&to=${to.unix()}`
        + (this.queryParams.timeBasedOn !== 'created_at'? `&timeRangeAttr=${this.queryParams.timeBasedOn}`: '')
      )
      .then(response => {
        // console.log('single day trend', this.singleDayTrend.date, response.data);
        this.singleDayTrend.chartData1 = {
          labels: _pluck(response.data, 'date'),
          datasets: [{data: _pluck(response.data, 'count'), lineTension: 0}]
        };
        this.singleDayTrend.chartData2 = {
          labels: _pluck(response.data, 'date'),
          datasets: [{data: _pluck(response.data, 'amount'), lineTension: 0}]
        };
      })
      .catch(err => {
        console.log(`Cannot get trends`, err);
      });
    },

    resetStat() {
      this.stat = {
        amount_all: 0,
        amount_cash: 0, amount_online: 0,
        amount_eat_in: 0, amount_to_go: 0, amount_delivery: 0,
        amount_qc: 0, amount_ue: 0, amount_fp: 0, amount_gf: 0, amount_co: 0,
        count_all: 0,
        count_cash: 0, count_online: 0,
        count_eat_in: 0, count_to_go: 0, count_delivery: 0,
        count_qc: 0, count_ue: 0, count_fp: 0, count_gf: 0, count_co: 0,
        count_users: 0
      };
      this.singleDayTrend = {
        date: new Date(),
        chartData1: {
          labels: [], datasets: [{data: []}]
        },
        chartData2: {
          labels: [], datasets: [{data: []}]
        }
      };
      this.drawPies(this.stat);
      this.drawTrends([]);
    },

    addTooltipTotal(h, {column, $index}) {
      return h(
        'el-tooltip',
        {
          props: {
            content: this.$t("ShopStat.Message.Total_amount_reminder"),
            placement: 'top'
          },
          domProps: {
            innerHTML: column.label + '<span class="el-icon-question"></span>'
          }
        },
        [h('span')]//WARNING: ???
      );
    },

    goToAdvShopStat() {
      this.$router.push({
        path: 'adv-shop-stat',
        // params: { shopId: this.shop.id, shopName: this.shop.name },
        query: { shopId: this.shop.id, shopName: this.shop.name }
      });
    }
  },

  data() {
    return {
      queryParams: {
        from: moment().startOf('month').toDate(),
        to: new Date(),
        timeBasedOn: 'created_at'
      },
      si: {id: 0},
      eaa: {id: 0},
      shop: undefined,

      stat: {
        amount_all: 0,
        amount_cash: 0, amount_online: 0,
        amount_eat_in: 0, amount_to_go: 0, amount_delivery: 0,
        amount_qc: 0, amount_ue: 0, amount_fp: 0, amount_gf: 0, amount_co: 0,
        count_all: 0,
        count_cash: 0, count_online: 0,
        count_eat_in: 0, count_to_go: 0, count_delivery: 0,
        count_qc: 0, count_ue: 0, count_fp: 0, count_gf: 0, count_co: 0,
        count_users: 0
      },
      pie1: {labels: [], datasets: [{data: []}]},
      pie2: {labels: [], datasets: [{data: []}]},
      pie3: {labels: [], datasets: [{data: []}]},
      pie4: {labels: [], datasets: [{data: []}]},
      trend1: {labels: [], datasets: [{data: []}]},
      trend2: {labels: [], datasets: [{data: []}]},
      trend3: {labels: [], datasets: [{data: []}]},
      trend4: {labels: [], datasets: [{data: []}]},
      trendChartOptions: {
        layout: {padding: {left: 24, right: 24}},
        scales: {
          xAxes: [{barPercentage: 1, categoryPercentage: 0.8, stacked: true}],
          yAxes: [
            {ticks: {min: 0, precision: 0}}
          ]
        }
      },

      products: [],
      productTableProps: {
        defaultSort: {
          prop: 'qty',
          order: 'descending'
        }
      },
      defaultProductImage: `${process.env.BASE_URL}img/dish.png`,

      singleDayTrend: {
        date: new Date(),
        chartData1: {
          labels: [], datasets: [{data: []}]
        },
        chartData2: {
          labels: [], datasets: [{data: []}]
        }
      },
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },
    userType() {
      return this.$store.getters.userType;
    },

    dateRangePickerEarliest() {
      if ([ 'gaa', 'si' ].indexOf(this.userType) >= 0)
        return 0;
      return moment().add(-3, 'months').startOf('day').unix();
    },

    vanillaPlatformLogoSrc() {
      return `${process.env.BASE_URL}${process.env.VUE_APP_POSLOGO}`;
    },

    tableOfPlatformStats() {
      return [
        {
          platform: 'qc',
          src: `${process.env.BASE_URL}${process.env.VUE_APP_POSLOGO}`,
          count: this.stat.count_qc,
          amount: this.stat.amount_qc
        },
        {
          platform: 'ue',
          src: `${process.env.BASE_URL}img/icons/ubereats.svg`,
          count: this.stat.count_ue,
          amount: this.stat.amount_ue
        },
        {
          platform: 'fp',
          src: `${process.env.BASE_URL}img/icons/foodpanda.svg`,
          count: this.stat.count_fp,
          amount: this.stat.amount_fp
        },
        {
          platform: 'gf',
          src: `${process.env.BASE_URL}img/brand/gofoodie.png`,
          count: this.stat.count_gf,
          amount: this.stat.amount_gf
        },
        {
          platform: 'co',
          src: `${process.env.BASE_URL}img/icons/counter.svg`,
          count: this.stat.count_co,
          amount: this.stat.amount_co
        }
      ];
    },
    displayLabels() {
      let labels = {}

      // Adjust wordings accordingly.
      if (this.$route.meta.retail === true) {
        labels = {
          LABEL_EAT_IN: this.$t('ShopStat.Self_Pickup'),
          LABEL_TO_GO: this.$t('ShopStat.Custom'),
          LABEL_DELIVERY: this.$t('ShopStat.Home_Delivery'),
          LABEL_MEAL_TYPES: this.$t('ShopStat.Pickup_Method'),
          LABEL_TAKE_MEAL_TIME: this.$t('ShopStat.Pickup_Time')
        };
      }
      else {
        labels = {
          LABEL_EAT_IN: this.$t('ShopStat.Dine_In'),
          LABEL_TO_GO: this.$t('ShopStat.Self_Pickup'),
          LABEL_DELIVERY: this.$t('ShopStat.Delivery'),
          LABEL_MEAL_TYPES: this.$t('ShopStat.Meal_Pickup_Method'),
          LABEL_TAKE_MEAL_TIME: this.$t('ShopStat.Meal_Pickup_Time')
        };
      }

      return labels;
      // dateRangeShortcuts: [
      //   {
      //     label: this.$t("ShopStat.Today"),
      //     from: moment().startOf('day').toDate(),
      //     // to: new Date()
      //   },
      //   {
      //     label: this.$t("ShopStat.Yesterday"),
      //     from: moment().add(-1, 'days').startOf('day').toDate(),
      //     to: moment().add(-1, 'days').endOf('day').toDate()
      //   },
      //   {
      //     label: this.$t("ShopStat.This_Week"),
      //     from: moment().startOf('isoWeek').toDate(),
      //     // to: new Date()
      //   },
      //   {
      //     label: this.$t("ShopStat.Last_Week"),
      //     from: moment().add(-1, 'week').startOf('isoWeek').toDate(),
      //     to: moment().add(-1, 'week').endOf('isoWeek').toDate(),
      //   },
      //   {
      //     label: this.$t("ShopStat.This_Month"),
      //     from: moment().startOf('month').toDate(),
      //     // to: new Date()
      //   },
      //   {
      //     label: this.$t("ShopStat.Last_Month"),
      //     from: moment().add(-1, 'month').startOf('month').toDate(),
      //     to: moment().add(-1, 'month').endOf('month').toDate(),
      //   }
      // ],

      // labels: {
      //   LABEL_EAT_IN: '內用',
      //   LABEL_TO_GO: '自取',
      //   LABEL_DELIVERY: '外送',
      //   LABEL_MEAL_TYPES: '取餐型態',
      //   LABEL_TAKE_MEAL_TIME: '取餐時間'
      // }
    },
    dateRangeShortcuts () {
      let  dateRangeShortcuts = [
        {
          label: this.$t("ShopStat.Today"),
          from: moment().startOf('day').toDate(),
          // to: new Date()
        },
        {
          label: this.$t("ShopStat.Yesterday"),
          from: moment().add(-1, 'days').startOf('day').toDate(),
          to: moment().add(-1, 'days').endOf('day').toDate()
        },
        {
          label: this.$t("ShopStat.This_Week"),
          from: moment().startOf('isoWeek').toDate(),
          // to: new Date()
        },
        {
          label: this.$t("ShopStat.Last_Week"),
          from: moment().add(-1, 'week').startOf('isoWeek').toDate(),
          to: moment().add(-1, 'week').endOf('isoWeek').toDate(),
        },
        {
          label: this.$t("ShopStat.This_Month"),
          from: moment().startOf('month').toDate(),
          // to: new Date()
        },
        {
          label: this.$t("ShopStat.Last_Month"),
          from: moment().add(-1, 'month').startOf('month').toDate(),
          to: moment().add(-1, 'month').endOf('month').toDate(),
        }
      ];
      return dateRangeShortcuts;
    }
  }
};

function _pluck(arr, key) {
  let ret = [];
  for (let i=0; i<arr.length; i++) 
    ret.push(arr[i][key]);
  return ret;
}
</script>

<style scoped>
.row > .col,
.row > [class*="col-"] {
  padding-left: 5px;
  padding-right: 5px;
}

</style>
